/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Добавить группу получателей скидки и её условия.
 */
export interface LoyaltyProductGroupBody { 
    /**
     * Размер скидки в %.
     */
    discountRate?: number;
    /**
     * Текстовое представление скидки.
     */
    discountText?: string;
    /**
     * Размер скидки в абсолютных величинах.
     */
    discountAbsolute?: number;
    /**
     * Условия.
     */
    discountOptions: string;
    /**
     * Код.
     */
    discountCode?: string;
    /**
     * Признак необходимости генерации изображения QR-кода в интерфейсе.
     */
    generateQRCode: boolean;
    /**
     * Id загруженного файла изображения с QR-кодом.
     * @deprecated
     */
    discountQRCodeFileId?: string;
    /**
     * наименование варианта продукта.
     */
    groupName?: string;
    /**
     * единый постоянный код или список кодов.
     */
    isPermanentCode?: boolean;
    /**
     * признак что каждый код одноразовый или многоразовый.
     */
    isMultipleCodeUse?: boolean;
    /**
     * максимальное кол-во применений кода за 30 дней (месяц), 0 - неограничено.
     */
    maxCodeUsePerMonth?: number;
    /**
     * ID файла с одноразовыми кодами.
     */
    codesFileId?: string;
    isGenerateBarcode?: boolean;
}

